import { ajaxWrapper } from "functions";
import load_icon_from_monster from "pages/session_tools/global_data/load_icon_from_monster.js";

function update_permisson(permission) {
	var location_id = permission.location_id;

	var permission_dict = window.secret_react_state.location_permissions;
	permission_dict[location_id] = permission;

	window.secret_react_state.setGlobalState("location_permissions", permission_dict);
}

export default update_permisson;
